<template>
<div class="md:grid md:grid-cols-3 lg:grid-cols-5 xl:flex xl:items-center">
    <Card v-for="trophy in trophies" :key="trophy.id" :trophy="trophy" />
</div>
</template>

<script>
import Card from '@/components/Home/KPIS/Cards/Format-0.vue'

export default {
    components: {
        Card
    },
    props: {
        trophies: {
            type: Array,
            required: true
        }
    }
}
</script>